module.exports = __webpack_public_path__ + "static/media/pedestrian.7ca5a168.svg";